export default {
      id: "header-right-usage",
      viewBox: "0 0 555 527",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#header-right",
      toString: function () {
        return this.url;
      }
    }